module.exports = __webpack_public_path__ + "img/warmup.4fab7782.png";